import { useEffect, useRef } from 'react';
import Chart from '../chart';
import { useTheme } from '../context/ThemeContext';

const numberFormatter = new Intl.NumberFormat('en-ZA', {
  maximumFractionDigits: 0,
});

export default function DriveValueTrendChart({ data = [] }) {
  const canvasRef = useRef(null);
  const chartRef = useRef(null);
  const { theme } = useTheme();

  useEffect(() => {
    const ctx = canvasRef.current?.getContext('2d');
    if (!ctx) return;

    chartRef.current?.destroy();

    chartRef.current = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: data.map((item) => item.month),
        datasets: [
          {
            label: 'Total Value Add',
            data: data.map((item) => item.totalValueAdd),
            borderRadius: 10,
            borderSkipped: false,
            backgroundColor: theme === 'dark' ? 'rgba(59,130,246,0.8)' : 'rgba(37,99,235,0.8)',
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          datalabels: { display: false },
          tooltip: {
            backgroundColor: 'rgba(15,23,42,0.92)',
            titleColor: '#e2e8f0',
            bodyColor: '#f8fafc',
            borderColor: 'rgba(148,163,184,0.3)',
            borderWidth: 1,
            callbacks: {
              label: (context) => `R ${numberFormatter.format(context.parsed.y)}`,
            },
          },
        },
        scales: {
          x: {
            ticks: {
              color: theme === 'dark' ? '#cbd5e1' : '#334155',
              maxRotation: 0,
            },
            grid: {
              display: false,
            },
          },
          y: {
            beginAtZero: true,
            ticks: {
              color: theme === 'dark' ? '#cbd5e1' : '#334155',
              callback: (value) => `R ${numberFormatter.format(value)}`,
            },
            grid: {
              color: theme === 'dark' ? 'rgba(148,163,184,0.2)' : 'rgba(148,163,184,0.25)',
              drawBorder: false,
            },
          },
        },
      },
    });

    return () => {
      chartRef.current?.destroy();
      chartRef.current = null;
    };
  }, [data, theme]);

  return (
    <div className="relative h-full w-full">
      <canvas ref={canvasRef} className="absolute inset-0 h-full w-full" />
    </div>
  );
}
